/* Modernsleeping main.js – SEO v6 (2026-10-08): ohne jQuery.
   Mobil (< 741 px): Judge.me-Bewertungsreiter beim Scrollen ab 200 px ausblenden,
   beim Oeffnen des Mini-Warenkorbs nach 1 s ausblenden. Tidio entfaellt (nicht mehr im Einsatz). */
(function () {
  if (window.innerWidth >= 741) return;
  function setTab(visible) {
    document.querySelectorAll('.jdgm-revs-tab-btn').forEach(function (el) {
      el.style.display = visible ? '' : 'none';
    });
  }
  var cartLayer = document.getElementById('min-cart-layer');
  if (cartLayer) {
    cartLayer.addEventListener('click', function () {
      setTimeout(function () { setTab(false); }, 1000);
    });
  }
  window.addEventListener('scroll', function () {
    setTab(window.pageYOffset <= 200);
  }, { passive: true });
})();
